<template>
  <div class="mainClass">
    <v-card class="mb-3">
      <div style="display: flex;justify-content: space-between;padding: 0.5rem">
      <div class="flex items-center">
        <span>
          تیکت ها
        </span>
      </div>
      <div>
        <v-btn v-if="getPermissionMixin('tickets-store')" color="primary" @click="dialog = true">ایجاد تیکت</v-btn>
      </div>
    </div>
    </v-card>
   <v-card class="card">
     <v-data-table
         :headers="headers"
         :items="tickets"
         :hide-default-footer="tickets.length === 0"
         no-data-text=""
     >
       <template v-slot:item.created_at="{ item }" >
         {{
           getPersianDate(item.created_at)
         }}
       </template>
       <template v-slot:item.priority="{ item }">
         <span class="d-inline badge badge-light-danger">{{priority(item.priority)}}</span>
       </template>
       <template v-slot:item.status="{ item }">
         <span class="badge badge-light-info">{{status(item.status)}}</span>
       </template>
       <template v-slot:item.operations="{ item }">
         <button 
         class="btn btn-outline btn-active-light-primary btn-hover-rotate-end btn-outline-dashed" 
         @click="showReplay(item.id)" 
         :disabled="!getPermissionMixin('tickets-showTicket')
         ">مشاهده</button>
       </template>
     </v-data-table>
     <v-row v-if="tickets.length === 0">
       <v-col cols="6" style="display: flex;flex-direction: column;padding-right: 3rem;margin: auto">
         <v-col>
           <span class="text-danger">توجه کنید!</span>
         </v-col>
         <v-col>
           <span>
             تاکنون هیچ تیکتی توسط شما ثبت نشده است. می توانید از تیکت ها برای رفع مشکلات خود استفاده کنید
           </span>
         </v-col>
         <v-col>
           <v-btn v-if="getPermissionMixin('tickets-store')" color="primary" @click="dialog = true">
             ایجاد تیکت
           </v-btn>
         </v-col>
       </v-col>
       <v-col cols="6">
         <img src="../../../assets/support.png" style="max-width: 21rem;">
       </v-col>
     </v-row>
   </v-card>
    <v-dialog
        v-model="dialog"
        max-width="676px"
    >
    <v-card class="model-content">
      <div style="display: flex;flex-direction: column;">
        <div class="close-svg" @click="dialog = false">
          <span >
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
            <rect xmlns="http://www.w3.org/2000/svg" opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
            <rect xmlns="http://www.w3.org/2000/svg" x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
            </svg>
          </span>
        </div>
        <div style="padding-bottom: 1rem;">
          <h2 class="mb-3" style="text-align: center">
            ارسال تیکت پشتیبانی
          </h2>
        </div>
        <v-row class="border-dashed border-warning" style="background-color: #fff8dd;">
          <v-col cols="1">
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path xmlns="http://www.w3.org/2000/svg" opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
              <path xmlns="http://www.w3.org/2000/svg" d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
            </svg>
          </v-col>
          <v-col>
            <v-col>
              <h5 >توجه کنید!</h5>
            </v-col>
            <v-col>
              <span class="fw-normal">برای حل مشکلات فنی فقط پاسخگویی با تیکتینگ انجام می شود. برای مشاوره و سوالات غیر فنی می توانید با شماره تماس <strong>09109855700</strong> تماس بگیرید.</span>
            </v-col>
          </v-col>
        </v-row>
        <div style="padding-top: 1rem">
          <div class="paddingTitle">
            <label>
              عنوان تیکت
            </label>
          </div>
            <div>
              <input v-model="title" placeholder="عنوان تیکت را وارد کنید" class="el-input__inner">
            </div>
        </div>
        <v-row>
          <v-col>
            <div class="paddingTitle">
              <label>اولویت</label>
            </div>
            <div>
              <select class="form-select" data-gtm-form-interact-field-id="1" v-model="prioritySelect">
                <option v-for="(item,id) in priorities" v-bind:key="id" :value="item.id">{{item.name}}</option>
              </select>
            </div>
          </v-col>
          <v-col>
            <div class="paddingTitle">
              <label>بخش مربوطه</label>
            </div>
            <div>
              <select class="form-select" data-gtm-form-interact-field-id="1" v-model="partSelect">
                <option v-for="(item,id) in parts" v-bind:key="id" :value="item.id">{{item.name}}</option>
              </select>
            </div>
          </v-col>
        </v-row>
        <div>
          <div class="paddingTitle">
            <label>پیام</label>
          </div>
          <div>
            <v-textarea v-model="comment" class="textArea" auto-grow rows="4" outlined></v-textarea>
          </div>
        </div>
        <div style="display: flex;justify-content: center;gap: 1rem">
          <v-btn @click="dialog=false">لغو</v-btn>
          <v-btn color="primary" @click="storeTicket()" :loading="loading">ارسال</v-btn>
        </div>
      </div>
    </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogDetail"
        max-width="900px"
    >
      <v-card style="min-height: 700px;padding: 2.3rem;background-color: #fcfdf4!important;">
        <v-row >
          <v-col cols="4" class="card" style="background-color:#f6f8fa;display: flex;flex-direction: column;align-items: center;padding: 2rem;gap: 1.5rem">
            <div>
              <img src="../../../assets/default.jpg" style="border-radius: 30px">
            </div>
            <div>
              <span>{{details?.user?.nickname}}</span>
            </div>
            <div>
              <span>{{details?.user?.mobile}}</span>
            </div>
            <div> ---------------------------</div>
            <div>
              شماره تیکت : {{details.ticket_number}}
            </div>
            <div>
              بخش : {{details?.part?.name}}
            </div>
            <div>
              اولویت : {{priority(details.priority)}}
            </div>
            <div>
              تاریخ ایجاد :{{details?.created_at}}
            </div>
          </v-col>
          <v-col cols="8" class="scroll-y" style="display: flex;flex-direction: column;padding: 2rem">
            <div class="justify-content-start d-flex" style="flex-direction: column;gap: 0.7rem">
                <div class="d-flex">
                  <div>
                    <img src="../../../assets/default.jpg" style="border-radius: 50%;width: 50px">
                  </div>
                  <div class="d-flex flex-column" style="padding-top: 0.7rem;padding-right: 1rem">{{details?.user?.nickname}}</div>
                </div>
                <div class="text-dark rounded fw-bold p-3 bg-gray-200">{{details.body}} </div>
              </div>
            <div v-for="(item,id) in replays" v-bind:key="id" style="gap: 1rem;padding: 1rem 0">
              <div v-if="item.admin" class="justify-content-end d-flex flex-column" style="padding: 1rem">
                <div class="d-flex flex-row-reverse">
                  <div>
                    <img src="../../../assets/driver.jpg" style="border-radius: 50%;width: 50px">
                  </div>
                  <div class="d-flex flex-column" style="padding-top: 0.7rem;padding-left: 1rem">ادمین :  {{item?.admin?.name +' '+ item?.admin?.family}}</div>
                </div>
                <div class="d-flex flex-row-reverse">
                  <div class="text-dark rounded fw-bold p-3 bg-gray-200 width-max">
                    {{item.body}}
                  </div>
                </div>
              </div>
              <div v-else class="justify-content-start d-flex" style="flex-direction: column;gap: 0.7rem">
                <div class="d-flex">
                  <div>
                    <img src="../../../assets/default.jpg" style="border-radius: 50%;width: 50px">
                  </div>
                  <div class="d-flex flex-column" style="padding-top: 0.7rem;padding-right: 1rem">{{item?.user?.nickname}}</div>
                </div>
                <div class="text-dark rounded fw-bold p-3 bg-gray-200 width-max">{{item.body}} </div>
              </div>
            </div>
            <v-divider></v-divider>
            <div>
              <textarea type="textarea" class="form-control form-control-lg mw-260px"
                        v-model="bodyRelay"
                        rows="2" placeholder="پیام خود را وارد کنید">
              </textarea>
            </div>
            <div>
              <v-btn color="primary" @click="replay()" :disabled="details.status === 0 || !getPermissionMixin('tickets-replay')"  :loading="loading">ارسال</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import Vue from 'vue'
export default {
  name: "test",
  data(){
    return {
      headers : [
        {
          text: 'شناسه',
          align: 'start',
          filterable: false,
          value: 'ticket_number'
        },
        { text: 'تاریخ', value: 'created_at' },
        { text: 'عنوان', value: 'title' },
        { text: 'متن', value: 'body' },
        { text: 'دپارتمان', value: 'part.name' },
        { text: 'اولویت', value: 'priority'},
        { text: 'وضعیت', value: 'status' },
        { text: 'عملیات', value: 'operations'},
      ],
      tickets : [],
      title : '',
      prioritySelect : '',
      partSelect : '',
      priorities : [
        {id  : 1 , name : 'کم'},
        {id  : 2 , name : 'متوسط'},
        {id  : 3 , name : 'زیاد'},
        {id  : 4 , name : 'خیلی مهم'},
      ],
      parts : [
        {id  : 1 , name : 'پشتیبانی'},
        {id  : 2 , name : 'خرابی ناوگان'},
        {id  : 3 , name : 'حادثه'},
        {id  : 4 , name : 'مالی'},
        {id  : 5 , name : 'شکایات'},
      ],
      getUrl : '',
      getShowUrl : '',
      storeReplayUrl : '',
      id : '',
      storeUrl : '',
      replays : [],
      loading : false,
      bodyRelay : '',
      details : '',
      comment : '',
      dialog : false,
      dialogDetail : false,
    }
  },
  mounted() {
    const role = localStorage.getItem('role')
    if (role === 'COMPANY' || 'role' === 'COMPANY_MEMBER')
    {
      this.getUrl = 'v2/company/tickets'
      this.getShowUrl = 'v2/company/tickets/showTicket'
      this.storeUrl = 'v2/company/tickets/store'
      this.storeReplayUrl = 'v2/company/tickets/reply'
    }
    else
    {
      this.getUrl = 'v2/factory/tickets'
      this.getShowUrl = 'v2/factory/tickets/showTicket'
      this.storeUrl = 'v2/factory/tickets/store'
      this.storeReplayUrl = 'v2/factory/tickets/reply'
    }
    this.getTickets()
  },
  methods : {
    priority(id) {
      switch (id) {
        case 1:
          return 'کم';
        case 2:
          return 'متوسط';
        case 3:
          return 'زیاد';
        case 4:
          return 'خیلی مهم';
        default:
          return id
      }
    },
    replay(){
      this.loading = true
      axiosApi().post(this.storeReplayUrl,{
        id : this.id,
        body : this.bodyRelay
      }).then(()=>{
        this.showReplay(this.id)
        this.bodyRelay = ''
        Vue.$toast.open({
          'message' : 'پیام با موفقیت ذخیره شد.',
          type : "success"
        })
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },
    status(id) {
      switch (id)
      {
        case 0:
          return 'بسته شده';
        case 1:
          return 'در انتظار پاسخ';
        case 2:
          return 'پاسخ داده شده';
        case 3:
          return 'در انتظار پاسخ ادمین';
        default:
          return  id
      }
    },
    getTickets(){
      axiosApi().get(this.getUrl).then((result)=>{
        this.tickets = result.data.data.tickets
      })
    },
    showReplay(id){
      this.id =  id
      axiosApi().post(this.getShowUrl,{
        id : this.id
      }).then((result)=>{
        this.details = result.data.data.ticket
        this.replays = result.data.data.replay
        this.details.created_at = this.getPersianDate(this.details?.created_at)
        this.dialogDetail = true
      })
    },
    storeTicket(){
      this.loading = true
      axiosApi().post(this.storeUrl,{
        part : this.partSelect,
        body : this.comment,
        priority : this.prioritySelect,
        title : this.title
      }).then(()=>{
        this.dialog = false
        this.loading = false
        Vue.$toast.open({
          message : 'تیکت با موفقیت ثبت گردید',
          type : 'success'
        })
        this.getTickets()
      }).catch(()=>{
        this.loading = false
      })
    },
    numberFormating(number){
      return  number.toLocaleString("en-US");
    },
  }
}
</script>

<style scoped>

.mainClass{
  background-color: #e1eff9;
  height: 100vh;
}
.btn.btn-outline:disabled{
  opacity: 0.5;
  cursor: default;
}
.card {
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 2rem;
  box-shadow: 0 0 20px 0 rgba(76,87,125,.1) !important;
}
.model-content{
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.1);
  padding: 2rem;
  background-color: #fcfdf4;
}
.close-svg {
  display: flex;
  flex-direction: row-reverse;
  cursor: pointer;
}
.border-dashed {
  border-style: dashed!important;
  border-color: #e4e6ef;
}
.border-warning {
  border-color: #ffc700!important;
}
.fw-normal {
  font-weight: 400!important;
}
.el-input__inner{
  -webkit-appearance: none;
  background-color: white;
  background-image: none;
  border-radius: 0.5rem;
  box-sizing: border-box;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  border: 0.5px solid #409eff;

  padding: 0 15px;
  width: 100%;
}
.textArea{
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.475rem;
}
.form-select {
  display: block;
  width: 100%;
  padding: 0.75rem 3rem 0.75rem 1rem;
  -moz-padding-start: calc(1rem - 3px);
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.1;
  color: #181c32;
  background-color: #fcfdf4;
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: 1px solid #e4e6ef;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0,0,0,.075);
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.paddingTitle{
  padding: 1rem;
}
.scroll-y {
  overflow-y: scroll;
  position: relative;
}
.justify-content-start {
  justify-content: flex-start!important;
}
.d-flex {
  display: flex!important;
}
.justify-content-end {
  justify-content: flex-end!important;
}
.p-3 {
  padding: 0.75rem!important;
}
.align-items-end {
  align-items: flex-end!important;
}
.width-max{
  width: max-content;
}
.form-control {
  margin: 1rem 0;
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #181c32;
  background-color: #fcfdf4;
  background-clip: padding-box;
  border: 1px solid #e4e6ef;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0,0,0,.075);
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
</style>
